import { FC, useState } from "react";
import { InputBaseProps, InputContainer } from ".";
import { CountryCodeSelect } from "components";
import { GetCountryCodesRes } from "api/network";

import PhoneInput from "react-phone-number-input/input";
import classNames from "classnames";
import { CountryCode } from "libphonenumber-js/types.cjs";

interface props extends InputBaseProps {
  borderless?: boolean;
  value: string;
  onChange: (v: string) => void;
}

export const PhoneNumberInput: FC<props> = (props) => {
  const [count, setCount] = useState<GetCountryCodesRes>();

  return (
    <InputContainer {...props}>
      <div
        className={classNames(
          "flex items-center rounded-[10px] h-[42px] border overflow-hidden",
          {
            "border-none": props.borderless,
            "border-error bg-error-light": props.hasError,
            "border-gray-300 bg-white": !props.hasError,
          }
        )}
      >
        <PhoneInput
          dir={"ltr"}
          value={props.value as any}
          country={count?.UniqueName as CountryCode}
          className="flex-1 bg-transparent text-sm px-2 outline-none"
          onChange={(v) => {
            try {
              props.onChange(v as any);
            } catch (error) {
              console.log(error);
            }
          }}
        />
        <div>
          <CountryCodeSelect value={count} onChange={setCount} />
        </div>
      </div>
    </InputContainer>
  );
};
